<template>
    <span> </span>
</template>
<script>

import { EventBus } from '@/app/shared/services/event-bus.js';
import $ from 'jquery';

class AutoCatchBarcodeScanner {
    // Method to initialize the barcode scanner
    initialize = () => {
        console.log('initialize')
 
        // Add an event listener for keypress events, using the keyup method as the handler
       document.addEventListener('keydown', this.keyup, true)

        // Clear any existing timeout handler to prevent unexpected behavior
        if (this.timeoutHandler) {
            clearTimeout(this.timeoutHandler)
        }

        // Set a timeout to clear the input string after a short delay
        this.timeoutHandler = setTimeout(() => {
            this.inputString = ''
        }, 10)
    }

    // Method `close method` will be fired when it is explicitly called in your code.
    // Typically, you would call this method when you want to stop the barcode scanner functionality, such as when a component is unmounted in Vue.js or when a specific event occurs in your application.
    // For example, you might call close in the beforeDestroy lifecycle hook of a Vue.js component to remove event listeners and clean up resources before the component is destroyed. Or you might call close in response to a user action, such as clicking a "Stop Scanning" button.
    close = () => {
        // Remove the event listener for keypress events, using the keyup method as the handler
        document.removeEventListener('keydown', this.keyup)
    }

    timeoutHandler = 0
    inputString = ''

    // Event handler that listens for key presses and processes them with a delay.
    // This is a common pattern for handling input with a delay, often used for scenarios like search-as-you-type.
    keyup = (e) => {
        let focusElem = $(':focus')
        // Check if the focused element is an input of type text but with an id that is not "searchPatientsFieldControl"
        if (focusElem.length > 0 && focusElem.is('input[type="text"]:not(#searchPatientsFieldControl)')) {
            return
        }
 
        // The handler accumulates characters until a certain timeout
        if (this.timeoutHandler) { 
            clearTimeout(this.timeoutHandler)
           

            console.log(e.key + " " + e.keyCode + " " + String.fromCharCode(e.keyCode))

            this.inputString += e.keyCode == 189 ? '-' : String.fromCharCode(e.keyCode);
            
            if (e.keyCode == 13 && this.inputString.length > 3) { 
                e.fromScanner = true 
                this.inputString = this.inputString.replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();

                EventBus.$emit('setAutoCatchBarcodevalue',  this.inputString); 
            }

        }
        // Set a timeout to process the accumulated input after a short delay
        this.timeoutHandler = setTimeout(() => {           
            // Clear the input string after processing
            this.inputString = ''
        }, 75)

    }
}

export default {
    name: 'barcode-scanner',
    data() {
        return {
            scanBarcodeElm: new AutoCatchBarcodeScanner(),
        }

    }, 
    created() {  
        this.scanBarcodeElm.initialize();
    },
    mounted(){
         EventBus.$on('keydownDetection', (e) => {
            this.scanBarcodeElm.keyup(e)  
        });
    }


}
</script>